'use strict';

module.exports = ['$resource', function ( $resource ) {

    let User = $resource('/users/:id',
        {
            id: '@id'
        },
        {
            'save': {method:'POST'},
            'update': {method: 'PATCH'}
        }
    );

    var save = User.save;

    // Required for "easy" .save in controllers
    User.save = function ( ...args ) {

        if( args[0].id ) {
            this.update.apply(this, args);
        } else {
            save.apply(this, args);
        }
    };

    return User;
} ] ;
